/*
 * Seamless colour switch (notes and markup: snippets/epg-colour-switch.liquid).
 *
 * The colour swatches stay plain links to the other colour's product page. This remembers where
 * the swatches were on screen, so the next page can open at the same spot and cross-fade (the
 * snippet's inline script reads this back on the next page).
 */
(function () {
  const swatches = document.querySelector('.productView .variant-cus');
  if (!swatches) return;

  swatches.addEventListener('click', (event) => {
    const link = event.target.closest('a[href]');
    if (!link || event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;

    // The colour already on screen: nothing to load.
    if (link.pathname === window.location.pathname) {
      event.preventDefault();
      return;
    }

    try {
      sessionStorage.setItem('epg-colour-switch', JSON.stringify({
        to: link.pathname,
        at: Date.now(),
        offset: Math.round(swatches.getBoundingClientRect().top),
        y: Math.round(window.scrollY),
      }));
    } catch (error) {
      // Storage blocked: the page still switches, just without keeping the scroll position.
    }
  });
})();
